import { render, staticRenderFns } from "./PayWay.vue?vue&type=template&id=66d03302&scoped=true&"
import script from "./PayWay.vue?vue&type=script&lang=js&"
export * from "./PayWay.vue?vue&type=script&lang=js&"
import style0 from "./PayWay.vue?vue&type=style&index=0&id=66d03302&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d03302",
  null
  
)

export default component.exports